import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');

// Timeout configuration (60 seconds for AI calls)
const AI_TIMEOUT = 60000;
const DEFAULT_TIMEOUT = 30000;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: DEFAULT_TIMEOUT,
});

// Helper to handle timeout errors with user-friendly messages
const handleApiError = (error, operation) => {
  console.error(`Error ${operation}:`, error);

  if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    throw new Error('Request timed out. The AI is taking longer than usual - please try again.');
  }

  if (!error.response) {
    throw new Error('Unable to connect to server. Please check your internet connection.');
  }

  throw new Error(error.response?.data?.message || `Failed to ${operation}`);
};

export const generateEmail = async (userInputs) => {
  try {
    const response = await api.post('/api/generate-email', userInputs, {
      timeout: AI_TIMEOUT
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'generate email');
  }
};

export const sendEmailToUser = async (email, output) => {
  try {
    const response = await api.post('/api/send-email', { email, output });
    return response.data;
  } catch (error) {
    handleApiError(error, 'send email');
  }
};

export const analyzeStory = async (params) => {
  try {
    const response = await api.post('/api/analyze-story', params, {
      timeout: AI_TIMEOUT
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'analyze story');
  }
};

export const improveEmail = async (params) => {
  try {
    const response = await api.post('/api/improve-email', params, {
      timeout: AI_TIMEOUT
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'improve email');
  }
};

export default api; 